import React from 'react';
import { Cell, ColumnInterface } from 'react-table';
import { Link } from 'react-router-dom';

import { TitleFilenameLabel, Tooltip } from '../..';

const defaultCellWidth = 130;
const defaultTooltipPosition = 'right';

interface TitleFilenameColumn extends ColumnInterface<TitleFilenameItem> {
    tooltipPosition: TooltipPosition;
}

/**
 * @typedef {TitleFilenameCellProps}
 * @property {Cell<TitleFilenameItem>} cell the react-table Cell instance for a TitleFilenameItem
 * @property {TitleFilenameColumn} column the react-table Row instance for a TitleFilenameItem
 */
interface TitleFilenameCellProps {
    cell: Cell<TitleFilenameItem>;
    column: TitleFilenameColumn;
}

/**
 * Displays a trqkSong.title and trqkAudio.filename as a link to a Track Detail page. The title and
 * filename are formatted distinctly, each in its own truncated line.
 * @param {TitleFilenameCellProps}
 */
export const TitleFilenameCell = ({
    cell,
    column,
}: TitleFilenameCellProps): JSX.Element => {
    const position = column?.tooltipPosition ?? defaultTooltipPosition;
    const width = (column?.width as number) ?? defaultCellWidth;
    const {
        value: { audioDeleted, filename, href, title },
    } = cell;

    const message =
        title && filename ? `${title} / ${filename}` : title || filename;

    return (
        <div className="flex flex-col justify-center leading-tight">
            <Tooltip message={message} position={position}>
                {href && (
                    <Link to={href}>
                        <TitleFilenameLabel
                            audioDeleted={audioDeleted}
                            title={title}
                            filename={filename}
                            width={width}
                            underline={true}
                        />
                    </Link>
                )}
                {!href && (
                    <TitleFilenameLabel
                        audioDeleted={audioDeleted}
                        title={title}
                        filename={filename}
                        width={width}
                        underline={false}
                    />
                )}
            </Tooltip>
        </div>
    );
};
